import * as React from 'react';
import { useSelector } from 'react-redux';
import { trackOffersNearbyClick } from './tracking';
import { NearbyNewbuildingsLink } from '../../components/NearbyNewbuildingsLink';
import { getNearbyNewbuildingsMapUrl } from '../../selectors/newbuilding';

export function NearbyNewbuildingsLinkContainer() {
  const nearbyNewbuildingsMapUrl = useSelector(getNearbyNewbuildingsMapUrl);

  if (!nearbyNewbuildingsMapUrl) {
    return null;
  }

  return <NearbyNewbuildingsLink url={nearbyNewbuildingsMapUrl} onClick={trackOffersNearbyClick} />;
}
